<template>
  <v-menu
    v-model="menu_ativo"
    :close-on-content-click="false"
    transition="slide-y-transition"
    :position-x="POSICAO_COMPUTED.x"
    :position-y="POSICAO_COMPUTED.y"
  >
    <div class="bg-white w-300 px-3 pt-3 pb-1">
      <div class="d-flex align-center pb-1">
        <v-icon :size="20" color="#333333">$OrderAlphabeticalAscending</v-icon>

        <span class="font-17 font-weight-medium ml-1">Ordenação</span>

        <v-spacer />

        <v-btn icon class="mr-n1" @click="menu_ativo = false">
          <v-icon :size="22">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="mt-1">
        <v-autocomplete
          v-model="ordenacao.coluna"
          label="Coluna"
          :items="props.headers"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details
          class="mb-4"
        />

        <v-autocomplete
          v-model="ordenacao.ordem"
          label="Classificação"
          :items="opcoes_ordem"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details
          class="mb-3"
        >
          <template #item="{ item }">
            <v-list-item-avatar :height="20">
              <v-icon :size="20" color="#555555">{{ item.icon }}</v-icon>
            </v-list-item-avatar>

            <v-list-item dense class="ml-n7">
              <v-list-item-title v-html="item.text" class="font-weight-regular" />
            </v-list-item>
          </template>
        </v-autocomplete>
      </div>

      <div class="d-flex justify-end pb-1">
        <v-btn small color="#042333" dark @click="ordenar">
          ok
        </v-btn>
      </div>
    </div>
  </v-menu>
</template>

<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
  ev_contextmenu_column: Object,
  headers: Array,
});

const emit = defineEmits(['ordenacao']);

const menu_ativo = ref(false);
const ordenacao = ref({
  coluna: '',
  ordem: 'ASC',
})

watch(() => props.ev_contextmenu_column, () => {
  props.ev_contextmenu_column.ev.preventDefault();
  menu_ativo.value = true;
  ordenacao.value.coluna = props.ev_contextmenu_column.header.value;
});

const POSICAO_COMPUTED = computed(() => {
  const { ev } = props.ev_contextmenu_column;

  return {
    x: ev ? ev.clientX : 0,
    y: ev ? ev.clientY : 0,
  };
});

const opcoes_ordem = [
  {
    text: 'Classificar de A a Z',
    icon: '$OrderAlphabeticalAscending',
    value: 'ASC'
  },
  {
    text: 'Classificar de Z a A',
    icon: '$OrderAlphabeticalDescending',
    value: 'DESC'
  },
];

function ordenar() {
  const ev = {
    ...ordenacao.value,
    nivel_linha: props.ev_contextmenu_column.row.$nivel_linha,
  };

  emit('ordenacao', ev)
}
</script>
